import { logger } from "logging";
import { CLIENT_URLS } from "constants/urls";
import { localStorageService } from "service/storage";
import { ADDRESS_TYPE } from "constants/address";
import { platformNames } from "shared/constants";


export declare type QueryParams = string | {
  [key: string]: string;
} | [string, string][];


export const checkIsBeautyPlatform = () => {
  if (__PLATFORM__ === platformNames.MEN || __PLATFORM__ === platformNames.NYKAA) {
    return true;
  }
  return false;
};


/**
 * @description
 * function that handles redirection user to checkout page from saved and new Address page
 * passing addressIdSame param to check whether the user changes the address on saved page or not
 * @returns redirects user to checkout page
 */
export const redirectToCheckoutPage = (history: any, isAddressIdSame: boolean = true, isAddressDtoNull: boolean, addressType: string, addressCount: number, setIsShipToAddressClick?: Function, srcPageIsImport?: boolean) => {
  try {
      if (history) {
        if (!isAddressIdSame) {
          let isAddressIdNotSame: any = !isAddressIdSame;
          // We are adding ADDRESS_ID_NOT_SAME to the localStorage to show the toaster on checkoutPage
          localStorageService.setItem("ADDRESS_ID_NOT_SAME", isAddressIdNotSame);
        }

        /**
         * Note: this block will execute
         * in case of user coming from import page
         * we need to redirect user to payment page in this case
         */
        if(srcPageIsImport && setIsShipToAddressClick) {
          setIsShipToAddressClick(true);
          return;
        }

        /**
         * Note: this block will execute
         * in case of new user and user is not
         * having and any default address
         */
        if (isAddressDtoNull) {
          const query = new URLSearchParams(history.location.search);
          if ((addressType === ADDRESS_TYPE.ADD || addressType === ADDRESS_TYPE.EDIT) && addressCount !== 0) {
            if (setIsShipToAddressClick) {
              setIsShipToAddressClick(true);
            }
            history.goBack();
            return;
          }
          /**
           * if url contains #disableBack then removing this part from URL
           * by current pathName and search
           * and removing the #disableBack url from stack by history.back();
           */
          if (history.location.hash === "#disableBack") {
            history.replace(history.location.pathname + history.location.search);
            history.goBack();
          }
          /**
           * Redirecting back to SPC payment page
           * if user is coming from SPC flow
           */
          if (query && query.get("fromSPC") === "true") {
            window.history.replaceState(null, document?.title, CLIENT_URLS.SPC_PAYMENT_BASE);
            window.location.reload();
            return;
          }
          /**
           * adding shipTothisAddressClicked to query param
           * to redirect to new payment page if user is not having
           * any saved payment modes
           */
          window.history.replaceState(null, document?.title, `${CLIENT_URLS.PAYMENT_BASE_URL}?shipTothisAddressClicked=true`);
          window.location.reload();

          return;
        }

        /**
         * send user two step back in case of edit or add new address
         */
        if ((addressType === ADDRESS_TYPE.ADD || addressType === ADDRESS_TYPE.EDIT) && addressCount !== 0) {
          history.go(-2);
          return;
        }

        history.goBack();
      }
  } catch (error: any) {
    logger.error(error);
  }
};
